import { Box, Typography } from "@mui/material"

const PaymentDiscount7 = () => {
  return (
    <Box
      sx={{
        width: "100%",
        p: 1,
        my: 1,
        backgroundColor: "white",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "50px",
        border: "1px dashed #3ebf90",
      }}
    >
      <Typography
        fontSize="14px"
        lineHeight="18px"
        fontWeight={600}
        color="#3ebf90"
      >
        65% DE DESCONTO
      </Typography>
    </Box>
  )
}

export default PaymentDiscount7
